var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"block":"","color":_vm.color,"disabled":_vm.disabled,"ripple":false}},[_c('span',{class:`font-title font-weight-black pre-line ${
        _vm.disabled ? 'grey-text' : 'white--text'
      }`},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('span',{staticClass:"grey--text"}),_vm._v(" "),_c('v-icon',{class:_vm.disabled ? 'grey-text' : '',attrs:{"color":"white","light":"","large":""}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }